<ng-container *transloco="let t; read: 'reports'">
<div class="p-5 relative">
  <drdp-title [title]="t('activityBank.title')"></drdp-title>
  <drdp-report-search [onlyActive]="true" [displayAgeGroup]="false" [requiredFields]="requiredFields" [downloadBtnText]="t('activityBank.downloadByChild')"
    [secondaryDownloadBtnText]="t('activityBank.downloadByClass')" [showStudentSelect]="true" [onlyLocked]="true" [is2025]="true" [isDownloadDisabled]="!reportData.length" [canSelectAll]="true"
    (showReportClicked)="showReport($event)" (downloadReportClicked)="downloadReport($event)" [showLocale]="true">
  </drdp-report-search>
  <drdp-activity-bank-results [reportData]="reportData"></drdp-activity-bank-results>
</div>
</ng-container>
